import HomeIndexPage from '$landing-page/site-pages/home-index-page';

export default HomeIndexPage;
